// extracted by mini-css-extract-plugin
module.exports = {"chatBox":"ChatBox_chatBox__1o4Q3","fullButton":"ChatBox_fullButton__3WsV_","padRight":"ChatBox_padRight__1bt14"};